module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comModal"
  }, [(_vm.modalType === 'input') ? _c('b-modal', {
    staticClass: "inputModal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.title,
      "close-title": _vm.cancelTitle,
      "ok-title": _vm.confirmTitle
    },
    on: {
      "ok": _vm.confirm,
      "cancel": _vm.cancel,
      "shown": _vm.focusInput
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmByEnter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.showEmptyAlert,
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.emptyInputAlert))])], 1) : (_vm.modalType === 'alert') ? _c('b-modal', {
    staticClass: "alertModal",
    class: _vm.alertType,
    attrs: {
      "id": _vm.modalId,
      "title": "",
      "hide-footer": ""
    },
    on: {
      "ok": function($event) {
        return _vm.confirm()
      }
    }
  }, [(_vm.alertType === 'fail') ? _c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.alertType === 'success') ? _c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.title) + "\n    ")]) : (_vm.modalType === 'confirm') ? _c('b-modal', {
    staticClass: "confirmModal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.title,
      "close-title": _vm.cancelTitle,
      "ok-title": _vm.confirmTitle
    },
    on: {
      "ok": function($event) {
        return _vm.confirm()
      }
    }
  }) : (_vm.modalType === 'preview') ? _c('b-modal', {
    staticClass: "previewModal",
    attrs: {
      "id": _vm.modalId,
      "title": "",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._t("modalContent")], 2) : (_vm.modalType === 'modal') ? _c('b-modal', {
    staticClass: "originalModal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.title,
      "close-title": _vm.cancelTitle,
      "ok-title": _vm.confirmTitle
    },
    on: {
      "ok": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._t("modalContent")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9e3bdea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/com-modal.vue
// module id = 196
// module chunks = 2